<template>
  <div>
    <b-tabs v-model="activeTab" justified nav-class="nav-tabs-main" content-class="p-3 text-muted">
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <h1 class="d-none d-sm-inline-block title">
            {{ $t("asset-group.organization") }}
          </h1>
        </template>
        <div class="card rounded p-4" v-if="activeTab == 0">
          <h1 class="title mt-1">{{ $t("asset-group.organization") }}</h1>

          <AssetGroupCategoryBoxes />
          <AssetGroupBoxes />
        </div>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">
            <h1>{{ $t("asset-group.list-view") }} </h1>
          </span>
        </template>
        <BgysAssetGroupCategoryAssetGroupInventoryListView v-if="activeTab == 1" />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">
            <h1 class="title">{{ $t("asset-group.degree-of-criticality") }}</h1 class="title">
          </span>
        </template>
        <BgysAssetGroupCategoryAssetGroupCriticalityListView v-if="activeTab == 2" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import BgysAssetGroupCategoryAssetGroupCriticalityListView from "../asset-group-inventory/bgys-asset-group-category-asset-group-criticality-view.vue";
import BgysAssetGroupCategoryAssetGroupInventoryListView from "../asset-group-inventory/bgys-asset-group-category-asset-group-inventory-list-view";
import AssetGroupBoxes from "./component/asset-group-boxes.vue";
import AssetGroupCategoryBoxes from "./component/asset-group-category-boxes.vue";

export default {
  components: {
    AssetGroupCategoryBoxes,
    AssetGroupBoxes,
    BgysAssetGroupCategoryAssetGroupInventoryListView,
    BgysAssetGroupCategoryAssetGroupCriticalityListView,
  },

  beforeDestroy() {
    //this.$store.commit("assetGroupBoxes/clear");
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    redirectToAssetGroupListView() {
      this.$router.push("/organization/asset-group-inventory/asset-groups");
    },
    redirectToInventory() {
      this.$router.push("/organization/asset-groups/inventory");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../entity/organization-entities-view.scss");
</style>
